import { CatalogBrandsGridBannerAsync } from './catalog-brands-grid-banner/catalog-brands-grid-banner.async'
import clsx from 'clsx'
import { FC, Fragment, ReactNode, useMemo } from 'react'

import { useIsSingleColumn } from '@/screens/catalog/ui/catalog-grid/use-is-single-column'

import { ProductCard } from '@/widgets/ProductCard'

import { useMediaQueries } from '@/shared/lib/hooks/useMediaQueries'
import { OrderType, TProduct } from '@/shared/types/product-types'

import { EmptyCatalog } from '../catalog-empty/catalog-empty'

import { CatalogBrandsGridLoader } from './catalog-brands-grid-loader/catalog-brands-grid-loader'

import cl from './catalog-brands-grid.module.scss'

export type CatalogBrandsGridProps = {
	items: TProduct[]
	bannerItem?: ReactNode
	hideMoreButton?: boolean
	isLoading?: boolean
	onReset?: () => void
}

const isProductShow = (title: string, price: number, ordeType: OrderType) =>
	title && (price || ordeType === OrderType.Prereservation || ordeType === OrderType.Archive)

export const CatalogBrandsGrid: FC<CatalogBrandsGridProps> = ({ items, isLoading, bannerItem, onReset }) => {
	const filteredItems = useMemo(
		() => items?.filter(({ TITLE, PRICE, ORDER_TYPE }) => isProductShow(TITLE, PRICE.VALUE, ORDER_TYPE)) || [],
		[items]
	)
	const { isMobile } = useMediaQueries()
	const isSingleColumn = useIsSingleColumn()

	if (!filteredItems.length && !isLoading) {
		return (
			<section className={cl.section} id="catalog-brands-listing">
				<EmptyCatalog onReset={onReset} />
			</section>
		)
	}

	if (isLoading) {
		return <CatalogBrandsGridLoader isMobile={isMobile} />
	}

	return (
		<section className={cl.section} id="catalog-brands-listing">
			<div className={clsx(cl.inner)} aria-busy={isLoading}>
				{filteredItems.map((item, index) => (
					<Fragment key={item.KOD}>
						{bannerItem && (
							<CatalogBrandsGridBannerAsync currentIndex={index} className={cl.banner}>
								{bannerItem}
							</CatalogBrandsGridBannerAsync>
						)}
						<div className={clsx(cl.item)}>
							<ProductCard key={item.KOD} data={item} type="wideOnMobile" isRatingMobileCompact={!isSingleColumn} />
						</div>
					</Fragment>
				))}
			</div>
		</section>
	)
}
